import React from 'react';
import { AlertCircle } from 'lucide-react';

interface ThemeWarningProps {
  error: string;
}

export const ThemeWarning: React.FC<ThemeWarningProps> = ({ error }) => {
  return (
    <div className="bg-amber-50 border-b border-amber-200 px-4 py-2">
      <div className="max-w-7xl mx-auto flex items-center space-x-2 text-amber-700">
        <AlertCircle size={16} />
        <span className="text-sm">Theme not loaded: {error}. Using default colors.</span>
      </div>
    </div>
  );
};
